// extracted by mini-css-extract-plugin
export default {"create_post":"CreatePost_create_post__gn8-w"};